import catchApiFailure from '../catch-api-error'
import ApiFactory, { ApiTypes } from '../../index'
import configBuilder from '../config-builder'

const api = ApiFactory.getApi(ApiTypes.member)

export const isValid = async () => true
export const url = () => `/v1/messages/counts`
export const execute = async (params) => api.get(url(), configBuilder(params)).catch(catchApiFailure)
